import { useSelector } from 'react-redux'
import { RootState } from '../redux'
import { Sector } from '../types'

export default function useSector(): Sector | undefined {
  return useSelector((state: RootState) => state.sectors.sector)
}
